export default __webpack_public_path__ + "static/media/RTR200FI_Posterior.5466f9a3.webp";